 
import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import App from './../app.jsx';
import ProtectedRoute from './ProtectedRoute.js'
import LoginV3 from './../pages/user/login-v3.jsx';
import Testing from '../pages/Testing/Testing.jsx';
import Layout from '../pages/Layout/Layout.jsx';
import Testing2 from '../pages/Testing/Testing2.jsx';
import Testing3 from '../pages/Testing/Testing3.jsx';
import Profile from '../pages/Profile/Profile.jsx';
import Callback from '../context/Callback.js';
import SellerProfile from '../pages/SellerProfile/SellerProfile.jsx';
import Support from '../pages/Support/Support.jsx';
import TransactionHistory from '../pages/TransactionHistory/TransactionHistory.jsx';
import TransactionRecord from '../pages/TransactionHistory/TransactionRecord.jsx';
import Vehicles from '../pages/Vehicles/Vehicles.jsx';
import RegisterV3 from '../pages/user/register-v3.js';
import RegisterV2 from '../pages/user/register-v2.jsx';
import BuyerRegisterV3 from '../pages/user/Buyer/buyer-register-v3.js';
import ChooseAction from '../pages/user/ChooseAction.jsx';
import Buyer from '../pages/Buyer/Buyer.jsx';
import BuyerSuccess from '../pages/Buyer/BuyerSuccess.jsx';
import Home from '../pages/Landing/Home.jsx';
import DashboardV3 from './../pages/dashboard/dashboard-v3.js';
import PageNotFound from '../pages/dashboard/PageNotFound.jsx';
import BuyerProfile from '../pages/Buyer/BuyerProfile.jsx';
// import DocumentOption from '../pages/Document/documentoption.jsx';
import Contract from '../pages/Document/Contract.jsx';
import Payment from '../pages/Document/Payment.jsx';
import Ownership from '../pages/Document/Ownership.jsx';
import Completion from '../pages/Document/Completion.jsx';
import Insurance from '../pages/Document/Insurance.jsx';
import PurchaseCompletion from '../pages/Document/PurchaseCompletion.jsx';
import SecurityFraud from '../pages/SecurityFraud/SecurityFraud.jsx';
import Security from '../pages/Landing/Security.jsx';
import CompleteProfile from '../pages/CompleteProfile/CompleteProfile.jsx';
import { SecurityPage, HelpPage, LegalPage } from '../public/routes';

const AppRoute = [
  {
    path: '/',              
    element: <App />,
    children: [
      {
        path: '',
        element: <Navigate to='/Home' />
      },

      {
        path: '',
        element: <Outlet />,
        children: [
          { path: 'Testing', element: <Testing /> },
          { path: 'Testing2', element: <Testing2 /> },
          { path: 'Testing3', element: <Testing3/> },
          { path: 'Layout', element: <Layout /> },
        ]
      },
      {
        path: 'Profile',
        element: <ProtectedRoute />,
        children: [{ path: '', element: <Profile /> }]
      },

      {
        path: 'SellerProfile',
        element: <ProtectedRoute />,
        children: [{ path: '', element: <SellerProfile /> }]
      },

      {
        path: 'support',
        element: <ProtectedRoute />,
        children: [{ path: '', element: <Support /> }]
      },

      {
        path: 'affarshistorik',
        element: <ProtectedRoute />,
        children: [
          { path: '', element: <TransactionHistory /> },
          { path: ':id', element: <TransactionRecord /> },
        ]
      },

      {
        path: 'fordon',
        element: <ProtectedRoute />,
        children: [{ path: '', element: <Vehicles /> }]
      },

      {
        path: 'CompleteProfile',
        element: <ProtectedRoute />,
        children: [{ path: '', element: <CompleteProfile /> }]
      },

     

      {
  path: 'Buyer',
  children: [
    { path: '', element: <Buyer /> },           
    { path: ':encrypted', element: <Buyer /> } 
  ]
},
      {
        path: 'BuyerSuccess',
        element: <ProtectedRoute />,
        children: [{ path: '', element: <BuyerSuccess /> }]
      },

         {
        path: 'BuyerProfile',
        element: <ProtectedRoute />,
        children: [{ path: '', element: <BuyerProfile/> }]
      },
      

      {
        path: 'user/*',
        element: <Outlet />,
        children: [
          { path: 'login-v3', element:<LoginV3 /> },
          { path: 'register-v3', element:<RegisterV3 /> },
          { path: 'register-v2', element:<RegisterV2 /> },
          { path: 'buyerRegister-v3', element:<BuyerRegisterV3 /> },
          { path: 'ChooseAction', element:<ChooseAction/> },
        ]
      },
      
 {
  path: 'Contract',
  children: [
    { path: ':id', element: <Contract /> }
  ]
}
,
      // The payment stage of a signed deal, on its own page — not the agreement, which stays
      // on /Contract/:id for the record.
 {
  path: 'Payment',
  children: [
    { path: ':id', element: <Payment /> }
  ]
}
,
      // The Ägarbyte stage of a paid deal — the stage after the payment. Reached when the seller
      // has confirmed the money arrived; the stage itself refuses anything earlier.
 {
  path: 'Ownership',
  children: [
    { path: ':id', element: <Ownership /> }
  ]
},
      // The seller's closing page: the sale is complete. Reached from the Ägarbyte stage once the
      // seller has stated the transfer reported; the page sends anyone else back to their own stage.
      // Deliberately not a deal-flow path (lib/dealSession): the deal is finished.
{
  path: 'Completion',
  children: [
    { path: ':id', element: <Completion /> }
  ]
}
,
      
      // The buyer's "Försäkra bilen" demo page, reached a few seconds after the seller has reported
      // the change of ownership. Hard-coded in the front end; a deal-flow path (lib/dealSession).
{
  path: 'Insurance',
  children: [
    { path: ':id', element: <Insurance /> }
  ]
},
      // The buyer's closing page ("Köpet är genomfört"), after Försäkra bilen. Hard-coded in the
      // front end. Deliberately not a deal-flow path (lib/dealSession): the deal is finished.
{
  path: 'PurchaseComplete',
  children: [
    { path: ':id', element: <PurchaseCompletion /> }
  ]
},
      { path: 'callback', element: <Callback/> },
      { path: 'dashboard', element: <DashboardV3 /> },
      { path: 'Home', element: <Home/> },
      // The public Swedish path shows the DESIGN-SYSTEM guide. The merge had
      // pointed it at feat/landing-lovable's MUI page, which put the footer's
      // "Security and fraud" link back on the pre-port green palette; the
      // themed guide was left at /Security, where nothing linked to it and
      // where it crashed on the ref-based LoginModal.
      { path: 'sakerhet-och-bedragerier', element: <Security /> },
      { path: 'Security', element: <Security /> },
      { path: 'en/security-and-fraud', element: <SecurityPage isEnglish /> },
      { path: 'hjalp', element: <HelpPage /> },
      { path: 'integritet', element: <LegalPage kind="privacy" /> },
      { path: 'villkor', element: <LegalPage kind="terms" /> },
      { path: 'cookies', element: <LegalPage kind="cookies" /> },
      // The MUI original, kept reachable while its content is reconciled
      // against the guide's own translation blocks.
      { path: 'sakerhet-och-bedragerier-v1', element: <SecurityFraud /> },

   
      { path: '*', element: <PageNotFound /> }
    ]
  }
];

export default AppRoute;
